module.exports = __webpack_public_path__ + "static/img/组 2839.64d41eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/images/组 2839.png
// module id = iR7k
// module chunks = 0